module.exports = __webpack_public_path__ + "img/btn_taiwan_off.14a52ead.png";